import(/* webpackMode: "eager" */ "/codebuild/output/src2287466501/src/src/app/[locale]/page.tsx");
